import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../../service/service.js';
import {BillingService} from '../../../service/billing/billingService.js';
import {ElementUtil} from '../../../utils/elementUtil.js';
import {ExportUtil} from '../../../utils/exportUtil.js';
import {TimeUtil} from '../../../utils/timeUtil.js';
import {StringUtil} from '../../../utils/stringUtil.js';
import {BaseComponent} from '../../basecomponent.js';


/* global customElements */
class InvoiceGrid extends BaseComponent {
	
	static get properties() {
		return {
			user: {type: Boolean}
		};
	}
	
	constructor() {
		super();		
		
		var invoiceGrid = this;
		setTimeout(function(){
			invoiceGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var invoiceGrid = this;
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},	
				{
					tag: 'vaadin-date-picker',
					'class': 'spacer-toolbar-item',
					itemid: 'filterStartDate',
					label: 'Filter Start Date',												
					name: 'filterStartDate',
					value: function() {
						return TimeUtil.formatDateForTimeField(TimeUtil.startYearInPast());	
					}()
				},
				{
					tag: 'vaadin-date-picker',
					'class': 'spacer-toolbar-item',
					itemid: 'filterEndDate',
					label: 'Filter End Date',												
					name: 'filterEndDate',
					value: function() {
						return TimeUtil.formatDateForTimeField(TimeUtil.endCurrentMonth());	
					}()
				},
				{
					tag: 'span',
					'class': 'spacer-toolbar-item',
					style: 'font-size: 24px; color: gray;',
					innerHTML: '|'
				},				
				{
					tag: 'dl-action-button',
					itemid: 'view',
					theme: 'primary',
					'class': 'spacer-toolbar-item',
					permissions: ['ADMIN_BILLING_ACCOUNTS:READ', 'COMPANY_ACCOUNT_MANAGEMENT:READ'],
					children:[
						ElementUtil.makeIcon('vaadin:invoice', ' View')
					],
					listeners: {
						click: function() {							
							actionView(grid.selectedItems[0]);
						}
					}					
				},
				{
					tag: 'dl-action-button',										
					'class': 'spacer-toolbar-item',
					permissions: ['ADMIN_BILLING_ACCOUNTS:READ', 'COMPANY_ACCOUNT_MANAGEMENT:READ'],
					children:[
						ElementUtil.makeIcon('vaadin:invoice', ' Preview Next Invoice')
					],
					listeners: {
						click: function() {							
							actionPreview();
						}
					}					
				}														
			]
		});
		
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true
			},			
			children: [					
				{						
					path: 'invoice.invoiceNo',
					header: 'Invoice No',						
					width: '9em'
				},		
				{						
					path: 'invoice.invoiceBeginDts',
					header: 'Begin Date',						
					width: '9em',				
					renderer: function(root, column, rowData) {
						root.innerHTML = TimeUtil.formatBillingCalendarDate(rowData.item.invoice.invoiceBeginDts);						
					}
				},
				{						
					path: 'invoice.invoiceCycleDts',
					header: 'End Date',						
					width: '9em',					
					renderer: function(root, column, rowData) {
						root.innerHTML = TimeUtil.formatBillingCalendarDate(rowData.item.invoice.invoiceCycleDts);						
					}
				},
				{						
					path: 'invoice.invoiceAmt',
					header: 'New Amount',
					'text-align': 'end',
					width: '9em',
					renderer: function(root, column, rowData) {
						root.innerHTML = StringUtil.currencyFormat(rowData.item.invoice.invoiceAmt);
					}
				},		
				{						
					path: 'invoice.currentDueAmt',
					header: 'Due Amount',
					'text-align': 'end',
					width: '9em',
					renderer: function(root, column, rowData) {
						root.innerHTML = StringUtil.currencyFormat(rowData.item.invoice.currentDueAmt);
					}
				},			
				{						
					path: 'invoice.activeStatus',
					header: 'Active Status',										
					'text-align': 'center',
					width: '9em'
				},
				{						
					path: 'invoice.createDts',
					header: 'Create Date',						
					width: '9em',					
					renderer: function(root, column, rowData) {
						var date = TimeUtil.parseDate(rowData.item.invoice.createDts);						
						root.innerHTML = TimeUtil.formatDateStandard(date);						
					}
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;
					grid.selectedItems = item ? [item] : [];
					if (grid.selectedItems.length > 0) {						
						ElementUtil.query(toolbar, 'view').disabled = false;
					} else {						
						ElementUtil.query(toolbar, 'view').disabled = true;
					}
				}
			}
		});		
		
		if (invoiceGrid.user) {
			//toolbar.classList.add('hide');
			//ElementUtil.query(grid, 'selectionColumn').hidden = true;
		}
		
		var footer = ExportUtil.createExportFooter({
			grid: grid,
			itemid: 'invoices',
			showDetail: false
		});

		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbar,
				grid,
				footer.footerContainer
			]
		});		
		invoiceGrid.append(flexLayout);		
		
		var actionRefresh = function() {
			
			var startDate = ElementUtil.query(toolbar, 'filterStartDate').value;
			var endDate = ElementUtil.query(toolbar, 'filterEndDate').value;			
			
			var options = {
				startDate: startDate,
				endDate: endDate
			};
			
			var loadMask = invoiceGrid.showLoading();
			BillingService.getAccountService().getAccountInvoices(invoiceGrid.detail.companyId, options)
			.then(function(invoices){							
				loadMask.remove();
				grid.activeItem = null;	
				invoices = invoices.sort(function(a, b){
					var bDate = new Date(b.invoice.invoiceBeginDts);
					var aDate = new Date(a.invoice.invoiceBeginDts);
					return TimeUtil.compare(bDate, aDate);
				});
			
				grid.items = invoices;
			}).catch(function(){
				loadMask.remove();
			});
				
		};
		actionRefresh();
		
		var actionView = function(record) {
			
			var viewWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'View Invoice',
				icon: 'vaadin:invoice',
				width: .75,
				height: .75,
				listeners: {
					ready: function() {						
						viewWin.show();
						
						var viewToolbar = ElementUtil.create({
							tag: 'dl-toolbar',
							slot: 'toolbar',
							theme: 'spacing',
							children: [								
								{
									tag: 'vaadin-button',
									itemid: 'print',
									theme: 'primary',
									'class': 'spacer-toolbar-item',									
									children: [
										ElementUtil.makeIcon('vaadin:print', ' Print')
									],
									listeners: {
										click: function () {
											actionPrint();
										}
									}
								},								
								{
									tag: 'dl-action-button',
									itemid: 'factor',
									'class': 'spacer-toolbar-item',
									permissions: ['ADMIN_BILLING_ACCOUNTS:READ'],
									children: [
										ElementUtil.makeIcon('vaadin:records', ' Factor Details')
									],
									listeners: {
										click: function () {
											actionFactorDetails();
										}
									}
								},
								{
									tag: 'dl-action-button',
									itemid: 'export',
									'class': 'spacer-toolbar-item',
									permissions: ['ADMIN_BILLING_ACCOUNTS:READ', 'COMPANY_ACCOUNT_MANAGEMENT:READ'],
									children: [
										ElementUtil.makeIcon('vaadin:file-text-o', ' Export')
									],
									listeners: {
										click: function () {
											actionExport();
										}
									}
								},
								{
									tag: 'dl-action-button',
									itemid: 'email',
									'class': 'spacer-toolbar-item',
									permissions: ['ADMIN_BILLING_ACCOUNTS:READ', 'COMPANY_ACCOUNT_MANAGEMENT:READ'],
									children: [
										ElementUtil.makeIcon('vaadin:envelope', ' Email')
									],
									listeners: {
										click: function () {
											actionEmailInovice();
										}
									}
								}

							]
						});
						
						//iframe
						var viewFrame = ElementUtil.create({
							tag: 'iframe',
							style: 'height: 99%; width: 100%; border: 0px;',
							slot: 'primary',
							src:  BillingService.getAccountService().viewInvoice(invoiceGrid.detail.companyId, record.invoice.invoiceNo)
						});
						
						//flex						
						var viewLayout = ElementUtil.create({
							tag: 'dl-flex-layout',
							properties: {
								contentOverflow: false
							},
							children: [
								viewToolbar,
								viewFrame
							]
						});	
						
						
						viewWin.addToContentElement(viewLayout);	
						
						var actionPrint = function() {
							var printWin = viewFrame.contentWindow;
							printWin.focus();
							printWin.print();
						};
						
						var actionFactorDetails = function() {
							//window with grid
							
							var factorWin = ElementUtil.create({
								tag: 'dl-dialog',
								title: 'Factor Details',
								icon: 'vaadin:records',
								width: 800,
								height: 400,
								listeners: {
									ready: function() {						
										factorWin.show();
										
										var factorToolbar = ElementUtil.create({
											tag: 'dl-toolbar',
											slot: 'toolbar',
											theme: 'spacing',
											children: [								
												{
													tag: 'vaadin-button',
													itemid: 'view',
													theme: 'primary',
													'class': 'spacer-toolbar-item',									
													children: [
														ElementUtil.makeIcon('lumo:eye', ' View Details')
													],
													listeners: {
														click: function () {
															actionViewDetails(factorGrid.selectedItems[0]);
														}
													}
												}
											]
										});										
										
																				
										var factorGrid = ElementUtil.create({
											tag: 'vaadin-grid',
											theme: 'row-stripes column-borders',
											'column-reordering-allowed': '',
											style: 'height: 100%;',
											slot: 'primary',
											defaults: {
												tag: 'vaadin-grid-sort-column',
												resizable: true
											},			
											children: [					
												{						
													path: 'itemDescription',
													header: 'Decription',						
													width: '9em'
												},		
												{						
													path: 'billingFactorTypeDescription',
													header: 'Factor Type',						
													width: '9em'
												},
												{						
													path: 'billedFactorCount',
													header: 'Factor Count',						
													width: '9em'
												},
												{						
													path: 'factorCount',
													header: 'Overridden',						
													width: '9em', 
													renderer: function(root, column, rowData) {
														var overridden = 'false';
														if (rowData.item.factorCount !== rowData.item.billedFactorCount) {
															overridden = 'true';
														}														
														root.innerHTML = overridden;
													}
												}
											],
											listeners: {
												'active-item-changed': function(event) {
													const item = event.detail.value;
													factorGrid.selectedItems = item ? [item] : [];
													if (factorGrid.selectedItems.length > 0) {						
														ElementUtil.query(factorToolbar, 'view').disabled = false;
													} else {						
														ElementUtil.query(factorToolbar, 'view').disabled = true;
													}
												}
											}
										});		
										
										var factorLayout = ElementUtil.create({
											tag: 'dl-flex-layout',
											children: [
												factorToolbar,
												factorGrid
											]
										});
										
										factorWin.addToContentElement(factorLayout);	
										
										var loadMask = factorGrid.showLoading();
										BillingService.getAccountService().getAccountFactorAuditsForInvoice(invoiceGrid.detail.companyId, record.invoice.invoiceNo)
										.then(function(audits){
											loadMask.remove();
													
											factorGrid.activeItem = null;		
											factorGrid.items = audits;		
												
										}).catch(function() {
											loadMask.remove();
										});	
										
										var actionViewDetails = function(audit) {
											
											var factorDetailWin = ElementUtil.create({
												tag: 'dl-dialog',
												title: 'Factor Details',
												icon: 'vaadin:records',
												width: 800,
												height: 400,
												listeners: {
													ready: function() {						
														factorDetailWin.show();
														
														var factorDetailGrid = ElementUtil.create({
															tag: 'vaadin-grid',
															theme: 'row-stripes column-borders',
															'column-reordering-allowed': '',
															style: 'height: 100%;',
															slot: 'primary',
															defaults: {
																tag: 'vaadin-grid-sort-column',
																resizable: true,
																listeners: {
																	'direction-changed' : function(event) {
																		if (event.detail && event.detail.value) {
																			grid.currentSortField = event.target.path;
																			grid.currentSortDirection = event.detail.value.toUpperCase();
																			factorPageToolbar.loadCurrentPage();
																		}
																	}
																}				
															},			
															children: [	
																{						
																	path: 'reference',
																	header: 'Reference Type',					
																	width: '9em'
																},
																{						
																	path: 'referenceNo',
																	header: 'Reference No',					
																	width: '9em'
																},
																{						
																	path: 'referenceId',
																	header: 'Reference Id',					
																	width: '9em'
																}	
															]
														});														
														
														var factorPageToolbar = ElementUtil.create({
															tag: 'dl-paging-toolbar',
															slot: 'footer',
															pageSize: 200,
															postinit: function(element) {
																element.grid = grid;
																element.loader = function(backingGrid, pageNumber, pagingToolbar) {
																	var pageRange = factorPageToolbar.pullRange();
																	var loadMask = grid.showLoading();

																	factorDetailGrid.currentFilter = {
																		offset: pageRange.offset,
																		max: pageRange.max,
																		sortField: backingGrid.currentSortField,
																		sortOrder: backingGrid.currentSortDirection
																	};

																	var successHandler = function(records) {
																		loadMask.remove();
																		factorDetailGrid.activeItem = null;						
																		factorDetailGrid.items = records.data;
																						
																		factorPageToolbar.totalRecords = records.totalNumber;
																		factorPageToolbar.updatePager();						
																	};

																	BillingService.getAccountService()
																	.getAccountFactorAuditDetails(audit.companyId, audit.accountFactorId, factorDetailGrid.currentFilter)
																	.then(function(records){							
																		successHandler(records);
																	}).catch(function(){
																		loadMask.remove();
																	});

																};
															},
															listeners: {
																ready: function() {					
																	factorPageToolbar.loadCurrentPage();
																}
															}

														});	
														
														var factorDetailLayout = ElementUtil.create({
															tag: 'dl-flex-layout',
															children: [																
																factorDetailGrid,
																factorPageToolbar
															]
														});
														factorDetailWin.addToContentElement(factorDetailLayout);
														
																												
													}
												}
											});
											
											
										};
										
									}
								}
							});
							
						};

						var actionExport = function() {
							//download
							var options = {
								type: 'PDF',
								download: true
							};
							BillingService.getAccountService().downloadInvoice(invoiceGrid.detail.companyId, record.invoice.invoiceNo, options);
						};

						var actionEmailInovice = function() {
							//window w form to get emails
							
							var emailWin = ElementUtil.create({
								tag: 'dl-dialog',
								title: 'Email Invoice',
								icon: 'vaadin:envelope',
								width: 600,
								height: 325,
								listeners: {
									ready: function() {						
										emailWin.show();
										
										//form 
										var emailFormPanel = ElementUtil.create({
											tag: 'dl-form-panel',
											itemid: 'form',
											children: [
												{
													tag: 'vaadin-form-layout',										
													children: [																																		
														{
															tag: 'vaadin-text-area',
															label: 'Emails (; or , separator)',
															name: 'emails',
															style: 'max-height: 150px; min-height: 150px;',
															required: true,
															maxlength: 1024
														},																																
														{
															tag: 'hr',
															colspan: 2
														},
														{
															tag: 'div',
															style: 'text-align: center;',
															colspan: 2,
															defaults: {
																tag: 'vaadin-button'
															},
															children: [
																{
																	theme: 'primary',
																	children: [
																		ElementUtil.makeIcon('vaadin:caret-right', ' Send')
																	],
																	listeners: {
																		click: function() {															

																			var data = emailFormPanel.getData();
																			if (!data.emails || data.emails === '') {
																				window.DL.MessageUtil.showToastError('Email address required', 'Validation Error');	
																			} else {																			
																				var loadMask = emailFormPanel.showLoading();
																				BillingService.getAccountService().emailInvoice(invoiceGrid.detail.companyId, record.invoice.invoiceNo, data.emails).then(function(){
																					loadMask.remove();

																					window.DL.MessageUtil.showToast('Success', 'Emailed invoice', {
																						theme: 'success',
																						position: 'top-stretch'
																					});	
																					emailWin.close();
																					
																				}).catch(function(){
																					loadMask.remove();
																				});
																			}

																		}
																	}
																},
																{
																	theme: 'tertiary',
																	innerHTML: 'Cancel',
																	style: 'margin-left: 10px;',
																	listeners: {
																		click: function() {
																			//cancel
																			emailWin.close();
																		}
																	}
																}
															]
														}
													]
												}
											]

										});
										emailWin.addToContentElement(emailFormPanel);											
										
									}
								}
							});
							
						};	
												
					}
				}
			});			
			
		};
		
		var actionPreview = function() {
			
			var viewWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Previewing Next Invoice',
				icon: 'vaadin:invoice',
				width: .75,
				height: .75,
				listeners: {
					ready: function() {						
						viewWin.show();
						
						var viewToolbar = ElementUtil.create({
							tag: 'dl-toolbar',
							slot: 'toolbar',
							theme: 'spacing',
							children: [								
								{
									tag: 'vaadin-button',
									itemid: 'print',
									theme: 'primary',
									'class': 'spacer-toolbar-item',									
									children: [
										ElementUtil.makeIcon('vaadin:print', ' Print')
									],
									listeners: {
										click: function () {
											actionPrint();
										}
									}
								}
							]
						});
						
						//iframe
						var viewFrame = ElementUtil.create({
							tag: 'iframe',
							style: 'height: 99%; width: 100%; border: 0px;',
							slot: 'primary',
							src:  BillingService.getAccountService().viewPreviewInvoice(invoiceGrid.detail.companyId)
						});
						
						//flex						
						var viewLayout = ElementUtil.create({
							tag: 'dl-flex-layout',
							properties: {
								contentOverflow: false
							},
							children: [	
								viewToolbar,
								viewFrame
							]
						});	
						
						
						viewWin.addToContentElement(viewLayout);							
					
						var actionPrint = function() {
							var printWin = viewFrame.contentWindow;
							printWin.focus();
							printWin.print();
						};
												
					}
				}
			});				
			
		};
		
	}
	
};
customElements.define('dl-account-invoice-grid', InvoiceGrid);
